import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

type Props = {
	iconUrl: string;
	title: ReactNode;
	description: ReactNode;
	showOutline?: boolean;
	enableHover?: boolean;
};

export const TemplateCard = ({ title, description, iconUrl, showOutline, enableHover }: Props) => (
	<TileContainer showOutline={Boolean(showOutline)} enableHover={Boolean(enableHover)}>
		<IconContainer>
			<Icon src={iconUrl} />
		</IconContainer>
		<Content>
			{title}
			{description}
		</Content>
	</TileContainer>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TileContainer = styled.div<{ showOutline: boolean; enableHover: boolean }>({
	display: 'flex',
	height: '94px',
	width: '100%',
	borderRadius: '8px',
	boxShadow: token(
		'elevation.shadow.raised',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`0 1px 1px 0 ${colors.N50A}, 0 0 1px 0 ${colors.N60A}`,
	),
	margin: `${token('space.100', '8px')} 0`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	outline: ({ showOutline }) =>
		showOutline ? `${token('color.border.selected', '#0C66E4')} solid 2px` : 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		boxShadow: ({ enableHover }) =>
			enableHover
				? token(
						'elevation.shadow.overlay',
						// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
						`0px 8px 12px 0px ${colors.N40}, 0px 0px 1px 0px ${colors.N60}`,
					)
				: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
					token('elevation.shadow.raised', `0 1px 1px 0 ${colors.N50A}, 0 0 1px 0 ${colors.N60A}`),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div({
	display: 'flex',
	width: '28%',
	maxWidth: '156px',
	height: '100%',
	alignItems: 'center',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	background: token('color.background.accent.gray.subtlest', colors.DN900),
	borderRadius: '8px 0 0 8px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	width: '67%',
	maxWidth: token('space.1000', '80px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Content = styled.div({
	margin: token('space.200', '16px'),
	alignSelf: 'center',
});
